export default "__VITE_ASSET__GiUmQyGG__"